import { useDownloadAgreementPdf } from '~/hooks/relationship/useDownloadAgreementPdf';
import { useLocaleKeys } from '~/i18n';
import { relationshipModel } from '~/models';
export function useClientFlowPdfDownload() {
    const { downloadAgreementPdf } = useDownloadAgreementPdf();
    const { t: pdfToastTexts } = useLocaleKeys('clientFlow.pdfToast');
    return {
        downloadPdf: (relationship)=>{
            const isAgreement = relationshipModel.isApproved(relationship);
            const clientName = relationshipModel.customerName(relationship);
            downloadAgreementPdf(relationshipModel.id(relationship), undefined, {
                ready: isAgreement ? pdfToastTexts.agreementReady({
                    clientName
                }) : pdfToastTexts.proposalReady({
                    clientName
                }),
                failed: isAgreement ? pdfToastTexts.agreementFailed({
                    clientName
                }) : pdfToastTexts.proposalFailed({
                    clientName
                })
            });
        }
    };
}
